import React, { useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import PrivateRoute from "components/PrivateRoute/PrivateRoute";
import DelegateRegistration from "modules/DelegateRegistration/DelegateRegistration";
import GuestRegistration from "modules/DelegateRegistration/GuestRegistration";
import MemberSearch from "components/MemberSearch/MemberSearch";
import _ from "lodash";

// Zustand store
import { useAppStore } from "../../stores";

// import permissions
import {
  usertype_permissions,
  credential_permissions,
} from "../../enums/PermissionEnums";

interface IRegistrationRouterProps {}

const RegistrationRouter: React.FC<IRegistrationRouterProps> = (props) => {
  // Zustand store
  const user = useAppStore((state) => state.user);
  const permissions = user?.permissions || [];
  const authenticated = useAppStore((state) => state.authentication?.isLoginSuccess || false);

  const navigate = useNavigate();
  const location = useLocation();

  const loadSearch = !!_.find(
    permissions,
    (p: { name?: string }) =>
      (p.name?.indexOf(credential_permissions.Assign) ?? -1) != -1 ||
      (p.name?.indexOf(credential_permissions.Admin) ?? -1) != -1 ||
      (p.name?.indexOf(usertype_permissions.BackOffice) ?? -1) != -1 ||
      (p.name?.indexOf(usertype_permissions.StateFed) ?? -1) != -1 ||
      (p.name?.indexOf(usertype_permissions.AffiliatePresident) ?? -1) != -1 ||
      (p.name?.indexOf(usertype_permissions.Designee) ?? -1) != -1

  );

  React.useEffect(() => {
    if (location.pathname === "/convention-registration") {
      if (loadSearch) {
        navigate("/convention-registration/search");
      } else {
        navigate("/convention-registration/current-user");
      }
    }
  });

  const onRowClick = (data: any, row:any) => {
    if (data[0] !== 0) {
      navigate(`/convention-registration/attendee/${row.attendeeId}`);
    } else {
      navigate(`/convention-registration/member/${row.affiliateGuid}/${row.individualGuid}`);
    }
  };

  return (
    <div>
      <Routes>
        <Route
          path="member/:affiliateGuid/:individualGuid"
          element={
            <PrivateRoute>
              <DelegateRegistration />
            </PrivateRoute>
          }
        />
        <Route
          path="attendee/:attendeeId"
          element={
            <PrivateRoute>
              <DelegateRegistration />
            </PrivateRoute>
          }
        />
        <Route
          path="search"
          element={
            <PrivateRoute>
              <MemberSearch
                title={"Member Registration Search"}
                onRowClick={onRowClick}
                registeredOnly={false}
                delegateOnly={false}
                subHeader={
                  "Search for a member to register for convention using one or more fields. Affiliate Presidents should search for their own record to register."
                }
              />
            </PrivateRoute>
          }
        />
        <Route
          path="guest-registration"
          element={
            <PrivateRoute>
              <GuestRegistration />
            </PrivateRoute>
          }
        />
        <Route
          path="current-user"
          element={
            <PrivateRoute>
              <DelegateRegistration onRowClick={onRowClick} />
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  );
};

export default RegistrationRouter;
